import * as Yup from "yup";

export const UserValidationSchema: Yup.ObjectSchema = Yup.object().shape({
  email: Yup.string().email().required("Dies ist ein Pflichtfeld."),
  firstName: Yup.string().required("Dies ist ein Pflichtfeld."),
  lastName: Yup.string().required("Dies ist ein Pflichtfeld."),
  role: Yup.string().required("Dies ist ein Pflichtfeld.")
});
